import { render, staticRenderFns } from "./businessLicense.vue?vue&type=template&id=ae5defa2&scoped=true&"
import script from "./businessLicense.vue?vue&type=script&lang=js&"
export * from "./businessLicense.vue?vue&type=script&lang=js&"
import style0 from "./businessLicense.vue?vue&type=style&index=0&id=ae5defa2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae5defa2",
  null
  
)

export default component.exports